import React, { Component } from "react";

import {
  Icon,
  Modal,
  Header,
  Button,
  Dropdown,
  Label,
} from "semantic-ui-react";

class EstimateModal extends Component {
  constructor() {
    super();
    this.state = {
      billinginfo: null,
      program: null,
      location: null,
      pminfo: null,
      billingList: [],
      locationList: [],
      programList: [],
    };
  }
  componentDidMount() {
    this.setState({
      billingList: this.props.billinginfo,
      locationList: this.props.locations,
      programList: this.props.programs,
    });
  }
  handlePmSelect(pminfo) {
    if (pminfo) {
      this.setState({
        pminfo,
        billingList: this.props.billinginfo.filter(
          (b) => b.custnumber === pminfo.custnumber
        ),
      });
    }
  }
  gendropdown = (key, text, array) => {
    return array.map((result) => {
      let newoption = {
        key: result[key],
        value: result,
        text: result[text],
      };
      return newoption;
    });
  };
  genPmInfoDropdown = (key, text, array) => {
    return array.map((result) => ({ key: result[key],
      value: result,
      text: `${result.contactname} - ${result.custname}`})
  );
  };
  render() {
    console.log("Pm Info", this.state.pminfo);
    let pms = this.genPmInfoDropdown("defnumber", "contactname", this.props.pms);
    let billinginfo = this.gendropdown(
      "id",
      "companyname1",
      this.props.billinginfo
    );
    let programs = this.gendropdown("id", "program", this.props.programs);
    let locations = this.gendropdown(
      "code",
      "description",
      this.props.locations
    );
    return (
      <div className="EstimateModal">
        <Modal
          open={this.props.showModal}
          onClose={() => this.props.handleclose()}
          closeOnEscape={true}
          closeOnRootNodeClick={true}
          size="small"
        >
          <Header as="h2">
            Please select who, what and where the estimate is for.
          </Header>
          <Modal.Content>
            <h4>Project Manager</h4>
            <Dropdown
              placeholder="Project Managers"
              fluid
              search
              selection
              options={pms}
              onChange={(e, { value }) => {
                this.setState({ pminfo: value });
              }}
            />
            <h4>Billing Contact</h4>
            <Dropdown
              placeholder="Billing Contact"
              fluid
              search
              selection
              options={billinginfo}
              onChange={(e, { value }) => {
                this.setState({ billinginfo: value });
              }}
            />
            <h4>Project</h4>
            <Dropdown
              placeholder="Projects"
              fluid
              search
              selection
              options={programs}
              onChange={(e, { value }) => {
                this.setState({
                  program: value,
                });
              }}
            />
            <h4>Location</h4>
            <Dropdown
              placeholder="Location"
              fluid
              search
              selection
              options={locations}
              onChange={(e, { value }) => {
                this.setState({
                  location: value,
                });
              }}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="green"
              type="submit"
              disabled={
                !this.state.billinginfo ||
                !this.state.program ||
                !this.state.location ||
                !this.state.pminfo
              }
              onClick={() => {
                this.props.populatestuff(
                  this.state.billinginfo,
                  this.state.program,
                  this.state.location,
                  this.state.pminfo
                );
                this.props.handleclose();
              }}
              inverted
            >
              <Icon name="checkmark" /> Create Estimate
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default EstimateModal;



// WEBPACK FOOTER //
// ./src/components/shared-components/estimatemodal.js